const o = {
    Unauth: 3e3,
    Close: 1e3,
  },
  r = {
    TokenExpiredReason: 'token_expired',
    InvalidTokenReason: 'invalid_token',
    UserLoggedOut: 'user_logged_out',
  },
  c = 3e3;
class i {
  connection = null;
  config;
  token = null;
  subscribersMap = /* @__PURE__ */ new Map();
  retryConnectionStart = null;
  retryConnectionTimeoutId = null;
  static RECONNECTION_TIMEOUT = 1e3 * 60 * 5;
  // 5min
  static CONNECTION_RETRY_TIMEOUT_STEP = c;
  static isLogoutEvent(t) {
    return t.code === o.Unauth && t.reason === r.UserLoggedOut;
  }
  static isTokenExpiredOrInvalidEvent(t) {
    return (
      t.code === o.Unauth &&
      [r.TokenExpiredReason, r.InvalidTokenReason].includes(t.reason)
    );
  }
  constructor(t) {
    this.config = t;
  }
  async tryReconnect() {
    if (
      (this.retryConnectionStart === null &&
        (this.retryConnectionStart = Date.now()),
      this.connectionTimeoutExceeded())
    ) {
      (this.retryConnectionStart = null),
        this.retryConnectionTimeoutId &&
          (clearTimeout(this.retryConnectionTimeoutId),
          (this.retryConnectionTimeoutId = null)),
        this.emit('timeout', new Error('Connection timed out'));
      return;
    }
    this.retryConnectionTimeoutId = setTimeout(() => {
      this.connect();
    }, i.CONNECTION_RETRY_TIMEOUT_STEP);
  }
  emit(t, e) {
    const n = this.subscribersMap.get(t);
    if (n) for (const s of n) s(e);
  }
  off(t, e) {
    const n = this.subscribersMap.get(t);
    n && n.delete(e);
  }
  disconnect() {
    this.connection &&
      (this.connection.close(o.Close), this.emit('connected', !1));
  }
  async connect() {
    try {
      if (
        (this.token || (this.token = await this.config.JWTTokenGetter()),
        typeof this.token != 'string')
      )
        throw new TypeError('Token must be a string');
      (this.connection = new WebSocket(this.config.uri, this.token)),
        this.connection.addEventListener('open', () => {
          this.emit('connected', !0),
            (this.retryConnectionStart = null),
            this.retryConnectionTimeoutId &&
              (clearTimeout(this.retryConnectionTimeoutId),
              (this.retryConnectionTimeoutId = null));
        }),
        this.connection.addEventListener('message', (t) => {
          const e = this.parseWSMessage(t.data);
          e && this.emit(e.type, e);
        }),
        this.connection.addEventListener('error', (t) => {
          this.emit('error', t);
        }),
        this.connection.addEventListener('close', (t) => {
          if (i.isLogoutEvent(t)) {
            this.token = null;
            return;
          }
          i.isTokenExpiredOrInvalidEvent(t) && (this.token = null),
            this.emit('connected', !1),
            this.tryReconnect();
        });
    } catch (t) {
      this.emit('error', t);
    }
  }
  parseWSMessage(t) {
    if (typeof t != 'string') return null;
    try {
      const e = JSON.parse(t);
      return !e.type || !e.data ? null : e;
    } catch (e) {
      return console.error(e), null;
    }
  }
  connectionTimeoutExceeded() {
    return this.retryConnectionStart === null
      ? !1
      : Date.now() >= this.retryConnectionStart + i.RECONNECTION_TIMEOUT;
  }
  on(t, e) {
    let n = this.subscribersMap.get(t);
    n || (n = /* @__PURE__ */ new Set()),
      n.add(e),
      this.subscribersMap.set(t, n);
  }
}
export { i as Pusher };
